import React, { useEffect } from "react";
import { useParams } from "react-router";
import styled from "@emotion/styled";
import { impersonateSessionToken } from "@api";
import { useImpersonateUser } from "@api/v1/hooks/useImpersonateUser";
import { LoadingProgressBar } from "@rentablo/components";

const Container = styled.div`
  width: 100%;
`;

export const Impersonate = () => {
  const { userId } = useParams<{ userId: string }>();
  const { mutate } = useImpersonateUser();

  useEffect(() => {
    if (!userId) return;
    mutate(
      { id: parseInt(userId, 10) },
      {
        onSuccess: async (impersonatedUserToken) => {
          // The impersonated token is already swapped into storage at this
          // point. The legacy v2 session step is best-effort — if it fails
          // (e.g. the session route isn't served by the API host), still
          // proceed so the admin isn't stranded on the loading screen.
          try {
            await impersonateSessionToken(impersonatedUserToken.username);
          } catch {
            // ignore: v2 session is optional for the React app
          }
          window.location.href = import.meta.env.VITE_APP_V2_URL || "/";
        },
        // If the token swap itself fails, go back to the admin search rather
        // than spinning forever.
        onError: () => {
          window.location.href = "/admin/users";
        },
      }
    );
  }, [userId, mutate]);

  return (
    <Container>
      <LoadingProgressBar />
    </Container>
  );
};
